import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'customer-invoices';

const updateCustomerInvoiceById = async (body, invoiceId) => {
  const method = 'PUT';
  const url = `${USE_CASE_URL}/${invoiceId}`;

  const json = await request({ method, url, body });
  return json;
};

export default updateCustomerInvoiceById;
